<template>
  <!-- 添加群聊组件 -->
  <div class="p-absolute top-0 right-0 bottom-0 left-0 bg-black-0-2" v-show="visible">
      <div class="p-absolute m-auto top-0 right-0 bottom-0 left-0 p-t-25 r-2 bg-white shadow-5-g-400 z-index-3" style="width: 80%; height: 92%;">
          <p style="position:absolute; top:0; left:0; padding-top:5px; padding-left:10px; width:100%; text-align:left; color:#653EB3; font-size:14px;">{{typeData.type==='ADD'?'创建群聊':'转发消息'}}</p>
          <i class="el-icon-circle-close y-fc-999 p-absolute top-5 right-10 f-s-20 cursor-pointer" @click="close"></i>
          <div class="p-relative f-left h-100-p bg-white b-r b-c-150" style="padding-top: 51px; width:300px">
              <div class="p-absolute w-100-p top-0 left-0">
                  <div class="d-table p-x-12 w-100-p b-b b-c-g-100" style="height: 51px;">
                      <div class="d-table-cell v-a-middle">
                          <label class="p-relative d-block h-30 bg-g-100" style="border-radius: 15px;" ref="labelRef">
                              <input class="form-element b-w-0 p-x-20 w-100-p h-30 l-h-30 bg-transparent" type="text" placeholder="搜索" v-model="value"  @focus="onFocusEventto" ref="inputRef">
                              <i class="el-icon-close f-s-18 l-h-30 p-absolute top-0 bottom-0 right-0 m-auto p-x-10 cursor-pointer" @click.prevent="clearValue" v-show="value"></i>
                          </label>
                      </div>
                  </div>
              </div>
              <!-- 点击网点查询时 -->
              <div class="h-100-p o-auto">
              <im-toGroupContact-list :width="imAsideLeft" v-if="kecontactItems.length > 0" :key="Math.random()" :items="kecontactItems" @createSession="createSession" />
              </div>
              <!-- 实时搜索 全部、联系人、网点 -->
              <im-contact-select-togroup :forwordTeamList="forwordTeamList" :reverseDelSession="reverseDelSession" :showSelectedStatus="showSelectedStatus"  :id="id" :typeData="typeData" :value="value" :togroup="togroup" :visible="visible" @createSession="createSession" @delSelectedSession="delSelectedSession" ref="contactSelectRef" v-if="toGroupVisible" />
          </div>
          <div class="h-100-p o-auto">
              <div class="p-relative p-x-15 p-t-25 h-100-p" style="padding-bottom:120px;">
                  <p class="p-absolute top-0 left-0 p-l-15 w-100-p f-s-14">已选择成员 <span class="c-blue">{{items.length}}</span>/{{teamlevel-1}}</p>
                  <div class="h-100-p o-auto">
                      <im-contact-list-group :items="items" ref="imContactListGroupRef" @reverseDelSelectedSession="reverseDelSelectedSession"/>
                  </div>
                  <div class="p-absolute bottom-0 left-0 w-100-p p-x-20" style="height:120px;">
                      <p v-if="typeData.type==='ADD'"><span class="c-red">* </span>设置群名称：</p>
                      <div v-if="typeData.type==='ADD'"><input class="form-element w-100-p m-t-8" type="text" maxlength="30" placeholder="请输入群名称，字符长度30以内" v-model="groupName" @input="groupNameInputEvent" /></div>
                      <div v-if="typeData.type==='FORWORD'"><textarea class="form-element w-100-p m-t-8" type="text" maxlength="500" placeholder="给对方留言" v-model="leaveMessage" /></div>
                      <div class="t-a-right p-t-10">
                          <button type="button" class="button m-r-10" @click="close">取消</button>
                          <button type="button" v-if="typeData.type==='ADD'" class="button button-blue" :disabled="disabledCp" @click="createTeam">确定</button>
                          <button type="button" v-if="typeData.type==='FORWORD'" class="button button-blue" :disabled="disabledCp" @click="forwardSend">发送</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import { htmlUtil } from '@/utils/util';
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    teamlevel: {
      type: Number,
      default: 200
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    im: {
      type: Object,
      default: function () {
        return {};
      }
    },
    teamCurrentList: {
      type: Array,
      default: function () {
        return [];
      }
    },
  },
  data: function () {
    return {
      forwordTeamList:[],
      leaveMessage:'',
      typeData:{},
      visible: false,
      value: '',
      items: [],
      groupName: '',
      groupNameDirty: false,
      privateTeamId: null,
      kecontactItems: [],
      contactLoading: false,
      imLoading: false,
      imAsideLeft:250,
      toGroupVisible:true,
      togroup: 0,
      crtSessionAccount:'',
      accid:'',
      reverseDelSession: {},
      showSelectedStatus: true
    };
  },
  components: {
    // 选择联系人
    'im-toGroupContact-list': () => import('../im-toGroupContact-list.vue'),
    // 选择联系人
    'im-contact-select-togroup': () => import('../im-contact-select-togroup.vue'),
    // 'im-contact-select': window.vueComponents.imContactSelect,
    // 已选联系人列表
    'im-contact-list-group': () => import('./im-contact-list-group.vue')
  },
  mounted: function () {
    var _self = this;
    this.bus.$on('togroupvals', function(msg){  //重点在这里
      // console.log("togroupval111s",msg);
      _self.searchCustomerInfos(msg);
    });
  },
  methods: {
    // 获取本地会话列表(联系人列表)
    getLocalSessions: function () {
      var that = this;
      // console.log('getLocalSessions');
      this.im.getLocalSessions({
        done: function (err, data) {
          if(data&&data.sessions&&data.sessions.length){
            that.$parent.onsessions(data.sessions);
            data.sessions.forEach(item=>{
             
            })
          }
        }
      });
    },
    forwardSend(){
      let that = this;
      if(that.typeData.data.length === 1){
        this.items.forEach(item => {
          let scene,to
          if(item.to){
            scene = item.scene;
            to = item.to;
          }else if(item.teamId){
            scene = 'team';
            to = item.teamId;
          }else if(item.logInId){
            scene = 'p2p';
            to = item.logInId;
          }else if(item.userCode){
            scene = 'p2p';
            to = item.userCode;
          }
          if(scene&&to){
            if(that.typeData.data.length === 1){
              this.im.forwardMsg({
                msg:that.typeData.data[0],
                scene: scene,
                to: to,
                done: function(error, msg){
                  that.close();
                  if(error){
                    // that.$emit('imAlert', {
                    //   message: error
                    // });
                  }else{
                    that.$emit('submitNewMessage', msg);
                    that.getLocalSessions();
                  }
                }
              })
              if(that.leaveMessage){
                this.im.sendText({
                  scene: scene,
                  to: to,
                  // 是否支持发送者多端同步
                  // isSyncable: true,
                  // 是否要存离线
                  isOfflinable: true,
                  // 是否计入消息未读数
                  isUnreadable: true,
                  isRoamingable:true,
                  isSyncable:true,
                  cc:true,//是否支持抄送
                  // 是否需要业务已读（包含该字段即表示需要），只有设置了业务已读，才可以调用getTeamMsgReads,getTeamMsgReadAccounts等相关方法
                  needMsgReceipt: scene === 'team',
                  text: that.leaveMessage.replace(/&nbsp;/g, ' '),
                  done: function(error, msg){
                    that.close();
                    if(error){
                      // that.$emit('imAlert', {
                      //   message: error
                      // });
                    }else{
                      that.$emit('submitNewMessage', msg);
                      that.getLocalSessions();
                    }
                  }
                })
              }
            }
          }
          that.bus.$emit('initforwordmesg',false);
          that.$emit('imTip', {
            message: '转发成功'
          });
          
        });
      }else{
        this.handleChooseForwardCallback(this.items);
        that.close();
        that.bus.$emit('initforwordmesg',false);
        that.$emit('imTip', {
          message: '转发成功'
        });
      }
    },
    handleChooseForwardCallback:function (selectedObj) {
      var that = this;
      
      function getPassward() {
        var $chars = '0123456789abcdef';
        var maxPos = $chars.length;
        var pwd = '';
        for (i = 0; i < 16; i++) {
          pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
      }

      function serializeMsg (obj) {
        var map = {
          "scene": 0,
          "to": 1,
          "from": 2,
          "fromClientType": 4,
          "fromDeviceId": 5,
          "fromNick": 6,
          "time": 7,
          "type": 8,
          "body": 9,
          "attach": 10,
          "idClient": 11,
          "idServer": 12,
          "resend": 13,
          "userUpdateTime": 14,
          "custom": 15,
          "pushPayload": 16,
          "pushContent": 17,
          "apnsAccounts": 18,
          "apnsContent": 19,
          "apnsForcePush": 20,
          "yidunEnable": 21,
          "antiSpamContent": 22,
          "antiSpamBusinessId": 23,
          "clientAntiSpam": 24,
          "antiSpamUsingYidun": 25,
          "needMsgReceipt": 26,
          "needUpdateSession": 28,
          "replyMsgFromAccount": 29,
          "replyMsgToAccount": 30,
          "replyMsgTime": 31,
          "replyMsgIdServer": 32,
          "replyMsgIdClient": 33,
          "threadMsgFromAccount": 34,
          "threadMsgToAccount": 35,
          "threadMsgTime": 36,
          "threadMsgIdServer": 37,
          "threadMsgIdClient": 38,
          "delete": 39,
          "callbackExt": 40,
          "subType": 41,
          "yidunAntiCheating": 42,
          "env": 43,
          "isHistoryable": 100,
          "isRoamingable": 101,
          "isSyncable": 102,
          "isMuted": 104,
          "cc": 105,
          "isInBlackList": 106,
          "isPushable": 107,
          "isOfflinable": 108,
          "isUnreadable": 109,
          "needPushNick": 110,
          "isReplyMsg": 111,
          "tempTeamMemberCount": 112
        };

        var sceneMap = {
          // 单人聊天
          p2p: 0,
          // 群聊
          team: 1,
          // 超大群
          superTeam: 5
        }
        var fromClientTypeMap = {
          'Android':1,
          'iOS':2,
          'PC':4,
          'WindowsPhone':8,
          'Web':16,
          'Server':32,
          'Mac':64
        }
        var typeMap = {
          text: 0,
          image: 1,
          audio: 2,
          video: 3,
          geo: 4,
          notification: 5,
          file: 6,
          tip: 10,
          robot: 11, // robotIn
          // robotOut: 12,
          g2: 12,
          custom: 100
        }

        if(obj.text){
          obj.body = obj.text;
        }
        if(obj.scene){
          obj.scene = sceneMap[obj.scene]
        }
        if(obj.fromClientType){
          obj.fromClientType = fromClientTypeMap[obj.fromClientType]
        }
        // if(obj.type){
        //   obj.type = typeMap[obj.type]
        // }

        if(typeof obj.file === 'object'){
          obj.attach = JSON.stringify(obj.file)
        }

        // 处理合并转发再合并转发
        if(typeof obj.content === 'string' && obj.content&&JSON.parse(obj.content).type===15){
          obj.attach = obj.content;
        }

        var data = {}
        for (var p in map) {
          if (obj.hasOwnProperty(p)) {
            data[map[p]] = obj[p]
          }
        }
      return data
      }

      var selectedTeams = [];
      var selectedFriends = [];
      
      for (var key in selectedObj) {
        if (Object.hasOwnProperty.call(selectedObj, key)) {
          var item = selectedObj[key];
          if (item.scene === 'team'){
            selectedTeams.push(item);
          }
          if (item.scene === 'p2p'){
            selectedFriends.push(item);
          }
          if(!item.scene){
            if(item.teamId){
              selectedTeams.push(item);
            }
            if(item.userCode){
              selectedFriends.push(item);
            }
            if(item.logInId){
              selectedFriends.push(item);
            }
          }
        }
      }

      var selectedItems = that.typeData.data;
      var serializedMsgs = [];
      var messageAbstract = [];
      for (var i = 0; i < selectedItems.length; i++) {
        var msg = selectedItems[i];
        that.crtSessionAccount = msg.sessionId.split('-')[1];
        that.accid = msg.scene=="p2p"?that.id:that.crtSessionAccount;
        if(messageAbstract.length < 2){
          messageAbstract.push({
            message: msg.type === 'text' ? msg.text : {
              'file': '[文件]',
              'image': '[图片]',
              'audio': '[语音]',
              'video': '[视频]',
              'geo': '[定位]',
              'tip': '[提示]',
              'notification': '[通知]',
              'robot': '[机器人]',
              'custom': '[自定义]',
            }[msg.type],
            sender: msg.fromNick
          })
        }

        for (var key in msg) {
          if (Object.hasOwnProperty.call(msg, key)) {
            var prop = msg[key];
            if (typeof prop === 'boolean'){
              msg[key] = Number(prop);
            }
            if (prop === undefined) {delete msg[key]}
          }
        }
        var serializedMsg = serializeMsg(msg)
        serializedMsgs.push(serializedMsg)
      }

      var fileHeader = {
        version:0,
        message_count: serializedMsgs.length
      }
      var fileString = '';
      var encoder = new TextEncoder();
      var password = getPassward();
      var rc4 = new RC4(password);
      // 文件内容字符串拼接
      console.log(serializedMsgs)
      fileString = fileString + JSON.stringify(fileHeader);
      for (var i = 0; i < serializedMsgs.length; i++) {
        var msg = serializedMsgs[i];
        fileString = fileString + '\n' + JSON.stringify(msg);
      }
      
      // 转 utf8 字节码
      fileString = encoder.encode(fileString);
      // console.log('转 utf8 字节码',fileString)
      // rc4 加密
      fileString = rc4.encrypt(fileString);
      // console.log('rc4 加密',fileString)
      // 字节码 转 unit8array
      fileString = new Uint8Array(fileString);
      // console.log('字节码 转 unit8array',fileString)
      var blob = new Blob([fileString], { type: "application/octet-stream" });  
      // console.log('blob',blob) 
      var browserMD5 = new browserMD5File();
      browserMD5.md5(
        blob,
        (err, fileStringMd5) => {
          if(err){
            console.log('err:', err);
          }else{
            that.im.getNosToken({
              callback: (_error, tokenData)=>{
                var fileUrl = privateConf.base_url +'/' + tokenData.bucket + '/' + tokenData.objectName + '?offset=0&complete=true&version=1.0';
          
                var xhr = new XMLHttpRequest();
                xhr.open('post', fileUrl)
          
                xhr.setRequestHeader('x-nos-token', tokenData.token);
                xhr.setRequestHeader('content-type', 'application/octet-stream');
                xhr.send(blob);
                xhr.onreadystatechange = function() {
                  if (xhr.readyState !== 4) {
                    return;
                  }     
                  if (xhr.status === 200) {
                    that.im.getUser({
                      account: that.accid,
                      sync: true,
                      done: function(err, selfInfo) {
                        var contentInfo = {
                          data: {
                            compressed: false,
                            encrypted: true,
                            md5: fileStringMd5,
                            messageAbstract: messageAbstract,
                            password: password,
                            url: privateConf.base_url+'/yunxin/' + decodeURIComponent(tokenData.objectName),
                            sessionID: that.crtSessionAccount,
                            sessionName: selfInfo?selfInfo.nick||'':'',
                          },
                          type: 15,
                        };
                        var contentString = JSON.stringify(contentInfo);
                
                        selectedTeams.length && selectedTeams.map((team)=>{
                          that.im.sendCustomMsg({
                            scene: "team",
                            to: team.to||team.teamId,
                            text: "[聊天记录]",
                            content: contentString,
                            pushContent: "[聊天记录]",
                            done: function(err, obj) {
                              that.$emit('submitNewMessage', obj);
                              that.getLocalSessions();
                              // console.log('call sendCustomMsg finish: ', err, obj);
                            }
                          })  
                          if(that.leaveMessage){
                            that.im.sendText({
                              scene: "team",
                              to: team.to||team.teamId,
                              // 是否支持发送者多端同步
                              // isSyncable: true,
                              // 是否要存离线
                              isOfflinable: true,
                              // 是否计入消息未读数
                              isUnreadable: true,
                              isRoamingable:true,
                              isSyncable:true,
                              cc:true,//是否支持抄送
                              // 是否需要业务已读（包含该字段即表示需要），只有设置了业务已读，才可以调用getTeamMsgReads,getTeamMsgReadAccounts等相关方法
                              needMsgReceipt: true,
                              text: that.leaveMessage.replace(/&nbsp;/g, ' '),
                              done: function(error, msg){
                                that.close();
                                if(error){
                                  // that.$emit('imAlert', {
                                  //   message: error
                                  // });
                                }else{
                                  that.$emit('submitNewMessage', msg);
                                  that.getLocalSessions();
                                }
                              }
                            })
                          }
                        });
                        selectedFriends.length && selectedFriends.map((friend)=>{
                          that.im.sendCustomMsg({
                            scene: "p2p",
                            to: friend.to||friend.logInId||friend.userCode,
                            text: "[聊天记录]",
                            content: contentString,
                            pushContent: "[聊天记录]",
                            done: function(err, obj) {
                              that.$emit('submitNewMessage', obj);
                              that.getLocalSessions();
                              // console.log('call sendCustomMsg finish: ', err, obj);
                            }
                          })  

                          if(that.leaveMessage){
                            that.im.sendText({
                             scene: "p2p",
                              to: friend.to||friend.logInId||friend.userCode,
                              // 是否支持发送者多端同步
                              // isSyncable: true,
                              // 是否要存离线
                              isOfflinable: true,
                              // 是否计入消息未读数
                              isUnreadable: true,
                              isRoamingable:true,
                              isSyncable:true,
                              cc:true,//是否支持抄送
                              // 是否需要业务已读（包含该字段即表示需要），只有设置了业务已读，才可以调用getTeamMsgReads,getTeamMsgReadAccounts等相关方法
                              needMsgReceipt: false,
                              text: that.leaveMessage.replace(/&nbsp;/g, ' '),
                              done: function(error, msg){
                                that.close();
                                if(error){
                                  // that.$emit('imAlert', {
                                  //   message: error
                                  // });
                                }else{
                                  that.$emit('submitNewMessage', msg);
                                  that.getLocalSessions();
                                }
                              }
                            })
                          }

                        });    
                      }
                    });
                  }
                };
              },
              nosToken: {
                nosScene: 'im',
                nosSurvivalTime: 86400
              },
              responseBody: {
                type: 'file'
              }
            });  
          }
        },
        progress => {
          // console.log('progress number:', progress);
        },
      );
    },
    onFocusEventto: function () {
      this.toGroupVisible = true;
    },
    searchCustomerInfos: function (item) {
      // console.log("111",item);
      var $this = this;
      $this.toGroupVisible = false;
      $this.contactLoading = true;
      $this.kecontactItems = [];
      axiosHttpIm.post('/webIM/searchCustomerInfo', {kcode: item.kCode}).then(
        function (response) {
          if (response.success && response.data) {
            $this.$nextTick(function () {
              this.contactLoading = false;
              this.kecontactItems = response.data.contactList;
            });
          } else if (!response.success) {
            // 这里说明请求k码的接口调用失败
          }
        },
        function () {
          $this.contactLoading = false;
        }
      );
    },
    // 创建群聊
    createTeam: function () {
      // console.log("1234",this.items);
      var accounts = this.items.map(function (item) {
        if(item.logInId){
          return item.logInId
        }else{
          return item.userCode;
        }
      });
      if (!this.groupName.trim() || this.items.length === 0) return;
      if(this.typeData.addAccoutId){//单聊建群时加入当前对话联系人并且去重
        accounts.push(this.typeData.addAccoutId);
      }
      // 添加本人
      accounts.push(this.id);
      var $this = this;
      // console.log("this.groupName",this.groupName);
      this.im.createTeam({
        type: 'advanced',
        name: htmlUtil(this.groupName),
        avatar: 'avatar',
        accounts: accounts,
        joinMode: 'noVerify',
        beInviteMode: 'noVerify',
        // 群邀请模式 manager all
        inviteMode: 'all',
        // 群信息修改权限 manager all
        updateTeamMode: 'all',
        // 群信息自定义字段修改权限 manager all
        updateCustomMode: 'all',
        level: $this.teamlevel,
        // 群简介
        intro: '',
        // 群公告
        announcement: '',
        // 备注
        ps: '',
        // 群扩展字段, 建议封装成JSON格式字符串
        custom: '{}',
        done: function (error, team) {
          // console.log("创建了高级群")
          $this.bus.$emit("selectNewChatRoom",'team-'+team.owner.teamId);//新创建的聊天室处于选中状态
          if (error) {
            var message = error.code === 404 ? '您选择的联系人没有注册过IM账号，创建群聊失败' : '错误代码' + error.code;
            $this.$emit('imAlert', {
              message: message
            });
          } else {
            $this.close();
          }
        }
      });
    },
    // 创建私人群, 用于判断创建群聊时判断该联系人是否可以给加入群聊
    // 生产环境能查出来的联系人都是注册过IM，只用于测试环境开发提醒
    crearePrivateTeam: function () {
      var accounts = [this.id];
      // 周冰冰：01698009、杨露：01722463
      if (this.id === '01722463') accounts.push('01698009');
      else accounts.push('01722463');

      var $this = this;
      this.im.createTeam({
        type: 'normal',
        name: '普通群',
        accounts: accounts,
        custom: JSON.stringify({ im_test_private_unique: true }),
        muteType: 'all',
        done: function (error, obj) {
          if (error) return;
          $this.privateTeamId = obj.team.teamId;
        }
      });
    },
    // 删除个人临时群
    dismissPrivateTeam: function (teamId) {
      this.im.deleteLocalMsgsBySession({
        scene: 'team',
        to: teamId,
        delLastMsg: true,
        done: function (error, obj) { }
      });
      this.im.deleteLocalSession({
        id: 'team-' + teamId,
        done: function (error, obj) { }
      });
      this.im.dismissTeam({
        teamId: teamId,
        done: function (error, obj) { }
      });
    },
    // 添加联系人
    createSession: function (item) {
      // console.log("45createSession",item);
      var $this = this;
      var userId = "";
      // 标记用户的IM注册状态
      item.registerStatus = true;
     if(item.logInId){
      userId = item.logInId;
      if (item.logInId === this.id || this.items.length >= this.teamlevel - 1) return;
     }else if(item.to) {
      userId = item.to;
      if (item.to === this.id || this.items.length >= this.teamlevel - 1) return;
     }else if(item.teamId) {
      userId = item.teamId;
      if (item.teamId === this.id || this.items.length >= this.teamlevel - 1) return;
     }else{
      userId = item.userCode;
      if (item.userCode === this.id || this.items.length >= this.teamlevel - 1) return;
     }
      
      for (var i = 0; i < this.items.length; i++) {
        // 避免重复添加联系人
        if(this.items[i].userCode){
          if (this.items[i].userCode === item.userCode) {
            return;
          }
        }else if(this.items[i].to){
          if (this.items[i].to === item.to || this.items[i].to === item.teamId || this.items[i].to === item.userCode|| this.items[i].to === item.logInId) {
            return;
          }
        }else if(this.items[i].teamId){
          if (this.items[i].teamId === item.teamId || this.items[i].teamId === item.to|| this.items[i].teamId === item.userCode|| this.items[i].teamId === item.logInId) {
            return;
          }
        }else{
          if (this.items[i].logInId === item.logInId) {
            return;
          }
        }
        
      }
      // 用临时创建的私人群检查该联系人是否注册过IM用户
      if (this.privateTeamId) {

        this.im.addTeamMembers({
          teamId: this.privateTeamId,
          accounts: [userId],
          custom: JSON.stringify({ im_test_private_unique: true }),
          done: function (error, obj) {
            if (error && error.code === 404) {
              item.registerStatus = false;
              // 需要重新改变对象的应用，否则子组件的数据状态不更新
              var index = $this.items.indexOf(item);
              $this.items.splice(index, 1, Object.assign({}, item));
            }
          }
        });
      }
      this.items.push(item);
      // console.log(this.items);
    },
    //删除选中的联系人
    delSelectedSession(data){
      console.log("data.keyName",data,data.keyName);
      try{
        this.items.forEach((item,index)=>{
          if(data.delItem[data.keyName] == item[data.keyName]){
            this.$delete(this.items,index);
            throw Error()
          }
        })
      }catch(e){

      }
      
      console.log("%c 选中的联系人","color: blue",this.items)
    },
    //点击右侧的删除，反向删除左侧选中的列表
    reverseDelSelectedSession(reverseDelSession){
      this.reverseDelSession = reverseDelSession;
    },
    // 填充群名称
    fillGroupName: function () {
      this.groupNameDirty = false;
      this.groupName = "客户管家高级群";
      // this.groupName = this.items.length > 0 ? this.userInfo.userName : '';
      // if (this.items[0]) this.groupName += '-' + this.items[0].userName;
      // if (this.items[1]) this.groupName += '-' + this.items[1].userName;
    },
    // 表单输入监听事件
    groupNameInputEvent: function (event) {
      if (this.groupName) {
        this.groupNameDirty = true;
      } else {
        this.groupNameDirty = false;
      }
    },
    // 清空表单值
    clearValue: function () {
      this.value = '';
    },
    // 打开、关闭组件
    open: function (val) {
      // console.log(val,'open');
      this.typeData = val;
      this.leaveMessage = '';
      if (this.visible) return;
      this.visible = true;
      // this.crearePrivateTeam();
    },
    close: function () {
      this.visible = false;
      // 重置选择组件
      this.value = '';
      this.groupName = '';
      this.groupNameDirty = false;
      this.items.splice(0, this.items.length);
      this.$refs.contactSelectRef.navSelctType = '0';
      if (this.privateTeamId) this.dismissPrivateTeam(this.privateTeamId);
      this.bus.$emit("closeMultipFlag",false);
    },
  },
  watch: {
    items: function (val, old) {
      if (!this.groupNameDirty) {
        this.fillGroupName();
      }
    },
    teamCurrentList:function(val){
      this.forwordTeamList = val;
      // console.log('teamCurrentList',val);
    }
  },
  computed: {
    disabledCp: function () {
      return !this.groupName || this.groupName.length > 30 || this.items.length === 0 || this.items.length > this.teamlevel - 1;
    }
  }
}
</script> 
